import React from 'react';
import Modal from './modal';
import Button from '../button/button';
import styles from './index.scss';

const RemoveModal = ({ title, onSubmit, onClose,content }) => {
    return (
        <Modal onClose={onClose} title={title}>
            <div className={styles.exitClassBox}>
                <div className={styles.exitContent}>{content}</div>
                <div className={styles.exitBtn}>
                    <Button
                        label={'取消'}
                        onClick={onClose}
                    />
                    <Button
                        theme={'submit'}
                        label={'确认'}
                        onClick={onSubmit}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default RemoveModal